<head>
  <title></title>
  <link rel="stylesheet" [href]="URL_CSS_TINGLE" />
  <link rel="stylesheet" [href]="URL_CSS_CONSENT" />
  <link rel="stylesheet" [href]="URL_CSS_CANDLE" />
</head>
<body>
  <input type="hidden" class="lgtSessionToken" [value]="sessionToken" name="lgtSessionToken" /><br />
  <input type="hidden" class="sessionId" [value]="sessionID" name="sessionId" /><br />
  <input type="hidden" class="NumOperacion" value="" name="NumOperacion" /><br />
  <div id="idDivText" class="lgtConsentModal"></div>
  <div id="idDivButton"></div>
</body>
